module.exports = __webpack_public_path__ + "media/images/consumer/signup/plans/pricing_plan_select/prepared@2x-456e46e162460f4e05c74767f631a322.jpg";